import { useState} from 'react';
import useFetch from './usefetch';
import "./styles/technology.css";

import one from "./assets/technology/image-launch-vehicle-portrait.jpg";
import two from "./assets/technology/image-spaceport-portrait.jpg";
import three from "./assets/technology/image-space-capsule-portrait.jpg";

import oneLand from './assets/technology/image-launch-vehicle-landscape.jpg';
import twoLand from './assets/technology/image-spaceport-landscape.jpg';
import threeLand from './assets/technology/image-space-capsule-landscape.jpg';

const Technology = () => {

    const ImageLand = [oneLand, twoLand, threeLand];
    const images = [one,two,three]
    const { dataTech, error } = useFetch('data.json');
    const [tech,setTech] = useState(0)

        const checkedInput = (e) => {
        const inputList = document.querySelectorAll('input[type="checkbox"]');
        inputList.forEach((input) => {
            input.checked = false;
            input.parentElement.classList.remove('active');
        })

        e.target.parentElement.classList.add('active')
    }


    return ( 
        <>
            {error && <div>{error}</div>}
            {dataTech &&  <div className="technologiesPage">
            <div className="technologyContent">
                <div className="info">
                    <p className="tagLine"><span className="tag">03</span>SPACE LAUNCH 101</p>
                    <div className="content">
                        <aside className="navButtons">
                            <label htmlFor="one" className='active'>1
                                    <input type="checkbox" name="one" id="one" value="0" checked onChange={e => {
                                        checkedInput(e);
                                        setTech(e.target.value)
                                }}/>
                            </label>
                            <label htmlFor="two">2
                                <input type="checkbox" name="two" id="two" value="1" checked onChange={e => {
                                        checkedInput(e);
                                        setTech(e.target.value)
                                }} />
                            </label>
                            <label htmlFor="three">3
                                <input type="checkbox" name="three" id="three" value="2" checked onChange={e => {
                                        checkedInput(e);
                                        setTech(e.target.value)
                                }} />
                            </label>
                        </aside>
                        <section className="techInfo">
                            <span>THE TERMINOLOGY...</span>
                                <h1 className="name">{dataTech[tech].name}</h1>
                            <article>
                                    <p className="about">{dataTech[tech].description}</p>
                            </article>

                        </section>
                    </div>
            </div>
                <div className="imageCont">
                        <img src={images[tech]} alt={dataTech[tech].name} className="desktop" />
                        <img src={ImageLand[tech]} alt={dataTech[tech].name} className='mobile' />
            </div>
        </div>
        </div> }
        </>
     );
}
 
export default Technology;